import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductsRoutingModule } from '../products/products-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SharedModule } from 'src/app/shared/shared.module';
import { RestaurantSelectionModule } from '../restaurant-selection/restaurant-selection.module';
import { RegionManagementComponent } from './region-management.component';
import { RegionManagementListComponent } from './region-management-list/region-management-list.component';
import { RegionManagementRoutingModule } from './region-management-routing.module';


@NgModule({
  declarations: [
    RegionManagementComponent,
    RegionManagementListComponent
  ],
  imports: [
    Ng2SearchPipeModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProductsRoutingModule,
    NgbModule,
    GalleryModule,
    CKEditorModule,
    NgxDropzoneModule,
    SharedModule,
    RegionManagementRoutingModule,
    RestaurantSelectionModule       
  ]
})
export class RegionManagementModule { }
